import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { FileListProps } from './types';
import { FileItem } from './FileItem';

export const FileList: React.FC<FileListProps> = ({
  files,
  maxFiles,
  onRemoveFile,
}) => {
  if (files.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        添付ファイル ({files.length}/{maxFiles})
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {files.map((file) => (
          <FileItem
            key={file.id}
            file={file}
            onRemove={onRemoveFile}
          />
        ))}
      </Box>
    </Box>
  );
}; 